import { MantineColor } from '@mantine/core'

export const QuotasHelper = {
  SERVICES: {},
  getQuotaColor: (percent: number): MantineColor => {
    switch (true) {
      case percent < 65:
        return 'green'

      case percent >= 75 && percent <= 95:
        return 'orange'

      case percent > 95:
        return 'red'

      default:
        return 'gray'
    }
  },
}
